module.exports = __webpack_public_path__ + "static/media/reproductor.a34b809c.PNG";